module.exports = __webpack_public_path__ + "static/media/trust_img2.e0e80a9d.png";